import { useState, useEffect } from "react";
import { getAccount, postPayIn } from "library/api";
import { useNavigate } from "react-router-dom";
import { PayInConf, PayInReview } from "./PayInPages";

const PAGES = {
  REVIEW: "review",
  CONFIRM: "confirm",
};

function PayIn(props) {
  const { location } = props;
  const navigate = useNavigate();
  const locationState = location?.state
    ? location.state
    : {
        product: {},
        commonData: {},
        paymentDetails: {},
        paymentMethod: {},
        amount: "0",
        selectedOption: "",
      };
  const {
    product,
    commonData,
    paymentDetails,
    paymentMethod,
    amount,
    selectedOption,
  } = locationState;
  const [currentPage, setCurrentPage] = useState(PAGES.REVIEW);
  const [payError] = useState(null);
  const [receiptNum, setReceiptNum] = useState(null);
  const editPayment = () => {
    navigate("/ways-to-pay", {
      state: {
        paymentInfo: commonData,
        bsb: paymentDetails.bsb,
        accountNum: paymentDetails.accountNum,
        selectedOption,
        amount,
      },
    });
  };
  const confirmPayment = async () => {
    try {
      const bankTransDetails = {
        account_number: paymentDetails.accountNum,
        bsb: paymentDetails.bsb,
        amount,
      };
      const { data: account } = await getAccount(commonData.accountId);
      const payInLink = account.links.find(({ rel }) => rel === "payin");
      const { data } = await postPayIn(payInLink.href, bankTransDetails);

      setReceiptNum(data.receipt_id);
      setCurrentPage(PAGES.CONFIRM);
    } catch (e) {
      if (e?.response?.status === 401) {
        navigate("/login");
      } else if (e?.response?.data) {
        navigate("/ways-to-pay", {
          state: {
            paymentInfo: commonData,
            pageError: e.response.data.title,
            bsb: paymentDetails.bsb,
            accountNum: paymentDetails.accountNum,
            selectedOption,
            amount,
          },
        });
      }
    }
  };

  useEffect(() => {
    if (!location?.state) {
      navigate("/ways-to-pay");
    }
  }, [location, navigate]);

  if (!location?.state) {
    return null;
  }

  switch (currentPage) {
    case PAGES.REVIEW: {
      return (
        <PayInReview
          product={product}
          commonData={commonData}
          paymentDetails={paymentDetails}
          paymentMethod={paymentMethod}
          error={payError}
          amount={amount}
          onConfirm={confirmPayment}
          onEdit={editPayment}
        />
      );
    }

    case PAGES.CONFIRM: {
      return (
        <PayInConf
          product={product}
          paymentMethod={paymentMethod}
          receiptNum={receiptNum}
          commonData={commonData}
          amount={amount}
          paymentDetails={paymentDetails}
          onBack={() => {
            navigate("/");
          }}
        />
      );
    }

    default: {
      return null;
    }
  }
}

export { PayIn };
